document.addEventListener('DOMContentLoaded', () => {
  const $root = $('.partners')

  if (!$root.length) {
    return
  }

  $root.on('click', '.topbar__link-container', function () {
    $(this).find('.topbar__link').select()
  })

  $root
    .find('.partner-customers')
    .on('click', '.customers-pagination > a, .customers-filter', function (e) {
      const url = $(this).attr('href') || $(this).data('href')
      e.preventDefault()

      const $customersContainer = $root.find('.partner-customers')

      $customersContainer.toggleClass('is-loading', true)

      $.get(url)
        .done(res => {
          history.replaceState({}, '', url)
          $customersContainer.html(res)
        })
        .always(() => {
          $customersContainer.toggleClass('is-loading', false)
        })
    })

  $root.find('.partners__account-select').change(function (e) {
    const affiliateId = $(this).val()

    const url = new URL(window.location.href)
    url.searchParams.set('a_id', affiliateId)

    window.location = url.toString()
  })

  const $chartContainer = $root.find('.partners-chart')

  if ($chartContainer.length) {
    const $chart = $root.find('#chart')
    const chartData = getDataForChart($chartContainer)
    drawChart($chart.get()[0], chartData.data, chartData.label, chartData.color)
    $chartContainer.on('click', '.partners-chart__title', function (e) {
      $chartContainer.find('.partners-chart__dot').removeClass('active')
      $(this).find('.partners-chart__dot').addClass('active')
      const chartData = getDataForChart($chartContainer)
      drawChart($chart.get()[0], chartData.data, chartData.label, chartData.color)
    })
  }

  function getDataForChart($el) {
    const $activeDot = $el.find('.partners-chart__dot.active')
    const color = $activeDot.css('background-color')
    const label = $activeDot.attr('data-label')
    const name = $activeDot.attr('data-name')
    const metrics = JSON.parse($el.attr('data-metrics'))
    const data = metrics.filter(metric => metric.name === name).sort((a, b) => a.id - b.id)
    return { label, color, data }
  }

  function drawChart(el, data, label, color) {
    const config = {
      type: 'line',
      data: {
        labels: data.map(item => {
          const date = new Date(item.created_at)
          return `${date.getDate()}/${date.getMonth() + 1}`
        }),
        datasets: [
          {
            label: label,
            backgroundColor: color,
            borderColor: color,
            borderWidth: 2,
            radius: 3,
            data: data.map(item => (item.name === 'active_subscribers' ? item.value : item.delta)),
            fill: false,
          },
        ],
      },
      options: {
        responsive: true,
        layout: {
          padding: {
            left: 20,
            right: 32,
            top: 20,
            bottom: 16,
          },
        },
        legend: {
          display: false,
        },
        title: {
          display: false,
          text: label,
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        hover: {
          mode: 'nearest',
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Date',
              },
              gridLines: {
                display: false,
              },
            },
          ],
          yAxes: [
            {
              display: true,
              scaleLabel: {
                display: false,
                labelString: 'Value',
              },
              gridLines: {
                color: '#E5E9F2',
              },
            },
          ],
        },
      },
    }
    const ctx = el.getContext('2d')
    if (window.myLine) window.myLine.destroy()
    window.myLine = new Chart(ctx, config)
  }
})
